import { db } from '../firebase';

export const sendBid = (payload) =>
  db.ref(`messages/bids`).push(payload);



// WEBPACK FOOTER //
// ./src/firebase/database/messages.js